import { TimezoneType } from '@wix/bookings-uou-types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getUoULocale } from '../utils/locale/locale';
import { BusinessInfo } from '../../legacy/types';
import { isAnywhereFlow } from '../utils/anywhere/anywhere';
import {
  getLanguage,
  getLocale,
} from '@wix/bookings-catalog-calendar-viewer-utils';
import { ViewMode } from '../types/types';
import {
  BasedOn,
  GetBookingsSettingsResponse,
} from '@wix/ambassador-bookings-v2-bookings-settings/types';

export type ServiceListContext = {
  isMultiServiceAppointmentEnabled: boolean;
  isPricingPlanInstalled: boolean;
  isAnywhereFlow: boolean;
  businessInfo: BusinessInfo;
  viewMode: ViewMode;
};

type CreateServiceListContextParams = {
  getBusinessResponse: GetBookingsSettingsResponse;
  flowAPI: ControllerFlowAPI;
  isPricingPlanInstalled: boolean;
  viewMode: ViewMode;
};

export const createServiceListContext = async ({
  flowAPI,
  getBusinessResponse,
  isPricingPlanInstalled,
  viewMode,
}: CreateServiceListContextParams): Promise<ServiceListContext> => {
  const {
    environment: { isPreview },
    controllerConfig: { wixCodeApi },
  } = flowAPI;
  const businessInfo =
    mapGetBusinessResponseToBusinessInfo(getBusinessResponse);

  businessInfo.language = getLanguage(wixCodeApi);
  businessInfo.regionalSettings = getLocale(wixCodeApi);

  const isMultiServiceAppointmentEnabled =
    getBusinessResponse.bookingsSettings!.multiServiceAppointments?.enabled ??
    false;

  const isAnywhereFlowInd = await isAnywhereFlow(wixCodeApi, isPreview);

  return {
    isMultiServiceAppointmentEnabled,
    isPricingPlanInstalled,
    isAnywhereFlow: isAnywhereFlowInd,
    businessInfo,
    viewMode,
  };
};

const mapGetBusinessResponseToBusinessInfo = (
  getBusinessResponse: GetBookingsSettingsResponse,
): BusinessInfo => {
  const siteProperties = getBusinessResponse.bookingsSettings!.siteProperties!;
  const displayTimeZone =
    getBusinessResponse.bookingsSettings!.displayTimeZone!;
  const timezoneProperties = {
    defaultTimezone:
      displayTimeZone?.basedOn === BasedOn.CUSTOMER_TIME_ZONE
        ? TimezoneType.CLIENT
        : TimezoneType.BUSINESS,
  };
  const { businessName, language, timeZone, locale } = siteProperties!;

  return {
    language: getUoULocale(language || ''),
    name: businessName!,
    regionalSettings: locale?.country!,
    timeZone: timeZone!,
    timezoneProperties,
  };
};
